import CardUserProfile from "@/components/Card/card-user-profile";
import Spinner from "@/components/Spinner";
import useCircleEventStore from "@/hooks/useCircleEventStore";
import { useGetMyCircle } from "@/hooks/useCircles";
import useMyProfileStore from "@/hooks/useMyProfileStore";
import { useTokenData } from "@/hooks/useTokenData";
import { Button, Modal, Radio } from "antd";
import { isEmpty } from "lodash";
import React, { useEffect, useMemo } from "react";

export interface postBroadcast {
  audienceType: "PUBLIC" | "CIRCLE" | "DEPARTMENT" | "PRIVATE";
  audienceID?: string | undefined;
  audienceName?: string;  
}

interface IProfileModalBroadcast {
  open: boolean;
  myDepartment: any;
  onChange: (val: postBroadcast) => void;
  selected: postBroadcast;
  onCancel: () => void;
}

const ProfileModalBroadcast: React.FC<IProfileModalBroadcast> = ({
  open,
  myDepartment,
  onChange,
  selected,
  onCancel
}) => {
  const { userView } = useMyProfileStore();
  const { refetch, isFetching: isLoadingMyCircles } = useGetMyCircle(
    userView?.userId as string,
  );
  const { myCircles } = useCircleEventStore();

  useEffect(() => {
    if (userView?.userId) {
      refetch();
    }
  }, [userView?.userId]);
  
  const tokenData = useTokenData();

  const isPremium = useMemo(() => tokenData?.isPremium === "true", [tokenData]);

  return (
    <Modal open={open} title="Broadcast Audience" onCancel={onCancel} footer={[<Button onClick={onCancel} type="primary">Save</Button>]}>
      <div className="py-4 flex flex-col gap-4">
        <div className="w-full flex justify-between items-center">
          <span>Everyone</span>
          <Radio
            className="mc-radio"
            onChange={() =>
              onChange({
                audienceType: "PUBLIC",
                audienceName:"Everyone"
              })
            }
            checked={selected.audienceType === "PUBLIC"}
          />
        </div>
        <div className="w-full flex justify-between items-center">
          <span>{isPremium ? `My Department: ${myDepartment?.name} Department` : `My Group: ${myDepartment?.name}`}</span>
          <Radio
            className="mc-radio"
            onChange={() =>
              onChange({
                audienceType: "DEPARTMENT",
                audienceID: myDepartment?.id,
                audienceName: `${myDepartment?.name} Department`
              })
            }
            checked={selected.audienceType === "DEPARTMENT"}
          />
        </div>
        <div className="w-full flex flex-col gap-4">
          <span className={(!isLoadingMyCircles && isEmpty(myCircles)) ? "text-neutral-500" : ""}>My Circles</span>
          <div className="flex flex-col gap-2">
            {isLoadingMyCircles ? (
              <div className="flex justify-center items-center py-4">
                <Spinner />
              </div>
            ) : (
              !isEmpty(myCircles) ? myCircles?.map((x) => (
                <div key={x?.id} className="flex justify-between items-center">
                  <CardUserProfile
                    item={{
                      firstName: x?.name,
                      id: x?.id,
                      avatarUrl: x?.imageUrl,
                      ...(x as any),
                    }}
                    findCGCTX="CIRCLE"
                    squareAvatar
                    avatarSize="xs"
                    variant="horizontal"
                    type="circle"
                    customType={
                      x?.privacy === "PUBLIC"
                        ? "Public Circle"
                        : "Private Circle"
                    }
                    disableHref
                  />
                  <Radio
                    className="mc-radio"
                    value={x?.id}
                    onChange={(e) =>
                      onChange({
                        audienceType: "CIRCLE",
                        audienceID: e?.target?.value,
                        audienceName: `${x?.name} Circle`
                      })
                    }
                    checked={selected.audienceID === x?.id}
                  />
                </div>
              )) : 
              <div>
                <p className="text-neutral-500">You have not joined any circles yet. Please visit the 'My Community' page and click 'Join Circle' in the Recommended Circles section.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ProfileModalBroadcast;
